//import * as firebase from "firebase/app";
import firebase from 'firebase';
import "firebase/auth";
import "firebase/firestore";

const config ={
  apiKey: "AIzaSyD8hzgD2Wbd_tBPdSrN84RvNN5Mo0fGa3M",
  authDomain: "moultrie-smt-db.firebaseapp.com",
  databaseURL: "https://moultrie-smt-db.firebaseio.com",
  projectId: "moultrie-smt-db",
  storageBucket: "moultrie-smt-db.appspot.com",
  messagingSenderId: "535573403841"
};

export const app = firebase.initializeApp(config);

export const db = firebase.firestore();

export default {app,db};